import { AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";
import { State } from "../model/state";

class StatesService {
  private instance: HttpService;
  private controllerName: string = 'states'; 

  constructor() {
    this.instance = new HttpService(this.controllerName);
  }

  public getAll(): Promise<AxiosResponse<State[]>> {
    return this.instance.get();
  }
}

export default StatesService;